enum ResponsibilityName {
  Boarder = 'Boarder',
  Groomer = 'Groomer',
  Staff = 'Staff',
  VetAssistant = 'Vet assistant',
  VetTech = 'Vet tech',
  Veterinarian = 'Vet',
}

export default ResponsibilityName
